import React from 'react';
import classnames from 'classnames';

import { isElementOfType } from '../../utilities/components';

import { Width } from './types';
import { WpTabs } from '../tabs';

import './WpPageHeader.scss';

export interface Props {
  children?: React.ReactNode;
  width?: Width;
  sticky?: boolean;
  slim?: boolean;
  bordered?: boolean;
  buttons?: React.ReactNode;
  topPadding?: 'none' | 'sm' | 'md' | 'lg';
}

const WpPageHeader: React.FC<Props> = ({
  children,
  width,
  sticky = false,
  slim = false,
  bordered = true,
  buttons,
  topPadding = 'none',
}: Props) => {
  const childrenLength = React.Children.count(children);
  const isLastElementTabs = children && childrenLength > 1 && isElementOfType(children[childrenLength - 1], WpTabs);

  const baseClassName = 'WpPageHeader';
  const classes = classnames(
    baseClassName,
    `${baseClassName}--${width}`,
    sticky ? `${baseClassName}--sticky` : false,
    slim ? `${baseClassName}--slim` : false,
    bordered ? `${baseClassName}--bordered` : false,
    topPadding !== 'none' ? `${baseClassName}--top-padding-${topPadding}` : false,
    isLastElementTabs ? `${baseClassName}--has-tabs` : false
  );

  return (
    <div className={classes}>
      <div className={`${baseClassName}__content ${baseClassName}__content--${width}`}>
        {React.Children.map(children, (child: React.ReactElement) => {
          if (child && isElementOfType(child, [WpTabs])) {
            return (
              <div className={`${baseClassName}__content__tabs`}>
                {React.cloneElement(child, { width })}
                {buttons && <span className={`${baseClassName}__content__tabs__buttons`}>{buttons}</span>}
              </div>
            );
          }
          return child;
        })}
        {!isLastElementTabs && buttons && <span className={`${baseClassName}__content__buttons`}>{buttons}</span>}
      </div>
    </div>
  );
};

export default WpPageHeader;
